/*
 * @Author: huanglei 1446129798@qq.com
 * @Date: 2024-01-05 15:01:45
 * @LastEditors: huanglei 1446129798@qq.com
 * @LastEditTime: 2024-01-05 15:06:00
 * @Description:
 */
export const EMAIL_BACK_URL =
  window.EMAIL_BACK_URL || "http://192.168.8.173:3000/send-email";
